module.exports = __webpack_public_path__ + "static/tat-38-be222ae5b6da6952f7a18c18c77a0fe2.jpg";